<script lang="ts">
    import {url} from "./url";
    import {onMount} from "svelte";
    import MapComponent from "./components/MapComponent.svelte";
    import {Marker, Popup} from "mapbox-gl";
    import WhenSearchInput from "./components/search/WhenSearchInput.svelte";
    import StaionSearchInputMock from "./components/search/StaionSearchInputMock.svelte";
    import SideSearch from "./components/SideSearch.svelte";
    import uPlot from 'uplot'
    import 'uplot/dist/uPlot.min.css';
    import * as turf from "@turf/turf";

    let promise: Promise<any>;
    let isError = false;
    let plotContainer;
    const datasetMetadata = JSON.parse(document.getElementById('datasetMetadata').innerHTML);

    let testData = [
        {
            station: "USC00010008", lat: 31.5702, lon: -85.2482, thresholdmm: 116.59, returnInterval: 10, durationHr: 6,
            data: [
                ["1963-09-28T19:00:00", 130.5],
                ["1965-08-05T22:00:00", 130.1],
                ["1981-02-11T01:00:00", 137.1],
                ["1987-03-01T06:00:00", 152.4]
            ]
        },
        {
            station: "USC00010063", lat: 34.211, lon: -87.1784, thresholdmm: 99.31, returnInterval: 10, durationHr: 6,
            data: [
                ["1972-01-05T10:00:00", 101.6],
                ["1967-04-26T08:00:00", 108],
                ["1951-03-29T11:00:00", 135.4],
                ["1980-09-25T15:00:00", 124.5]
            ]
        },
        {
            station: "USC00010140", lat: 32.2322, lon: -87.4104, thresholdmm: 106.93, returnInterval: 10, durationHr: 6,
            data: [["1967-10-31T02:00:00", 109],
                ["1971-09-27T09:00:00", 157.5],
                ["1971-12-07T03:00:00", 137.1],
                ["1979-03-04T05:00:00", 139.7]
            ]
        },
        {
            station: "USC00010252", lat: 31.3071, lon: -86.5226, thresholdmm: 129.29, returnInterval: 10, durationHr: 6,
            data: [["1980-10-01T06:00:00", 175.3],
                ["1981-02-10T20:00:00", 187.9],
                ["1984-06-01T06:00:00", 132.1],
                ["1988-10-01T06:00:00", 188]
            ]
        },
        {
            station: "USC00010369", lat: 33.2941, lon: -85.7788, thresholdmm: 101.09, returnInterval: 10, durationHr: 6,
            data: [
                ["1957-06-05T00:00:00", 135.4],
                ["1969-05-09T03:00:00", 107.6],
                ["1976-01-26T10:00:00", 124.5],
                ["1979-02-25T11:00:00", 121.9]
            ]
        },
        {
            station: "USC00010390", lat: 34.7752, lon: -86.9508, thresholdmm: 100.58, returnInterval: 10, durationHr: 6,
            data: [["1983-05-19T11:00:00", 104.1],
                ["1985-09-01T06:00:00", 172.7],
                ["1987-03-01T06:00:00", 188],
                ["1988-08-01T06:00:00", 175.3]
            ]
        },
        {
            station: "USC00010402", lat: 31.182, lon: -87.439, thresholdmm: 135.38, returnInterval: 10, durationHr: 6,
            data: [["1955-04-13T12:00:00", 188.8],
                ["1984-08-01T17:00:00", 205.7],
                ["1993-11-15T17:00:00", 190.5],
                ["2002-11-01T06:00:00", 222.8]
            ]
        },
        {
            station: "USC00010748", lat: 33.6971, lon: -87.6488, thresholdmm: 104.14, returnInterval: 10, durationHr: 6,
            data: [["1948-11-19T11:00:00", 338.8],
                ["1949-05-02T06:00:00", 152.4],
                ["1956-12-12T15:00:00", 107.3],
                ["1961-02-23T04:00:00", 227.3]
            ]
        },
        {
            station: "USC00010957", lat: 34.2008, lon: -86.1633, thresholdmm: 98.81, returnInterval: 10, durationHr: 6,
            data: [["1952-08-30T05:00:00", 104.8],
                ["1971-07-16T11:00:00", 107.1],
                ["1978-12-09T18:00:00", 116.8],
                ["1981-08-30T07:00:00", 99]
            ]
        },
        {
            station: "USC00011099", lat: 34.9786, lon: -85.8008, thresholdmm: 88.39, returnInterval: 10, durationHr: 6,
            data: [["1985-08-17T07:00:00", 94],
                ["1986-08-30T14:00:00", 101.6],
                ["1989-07-04T07:00:00", 106.5],
                ["1994-05-27T13:00:00", 114.3]
            ]
        }
    ]

    let filteredTestData = [...testData]
    let stationSelected = null;
    let startDateSelected = null;
    let endDateSelected = null;
    let timeValues = []
    let dataValues;
    let data = [];
    let points = [];

    $: url.subscribe(url => {
        stationSelected = url.searchParams.get('station');
        startDateSelected = url.searchParams.get('startDate')
        endDateSelected = url.searchParams.get('endDate')
        if (stationSelected !== null) {
            filteredTestData = [...testData].filter(station => station.station == stationSelected)
        } else {
            filteredTestData = [...testData]
        }
        if (startDateSelected !== null && endDateSelected !== null) {
            filteredTestData.forEach(station => {
                station.data = station.data.filter(time => {
                    let startDateTime = new Date(startDateSelected)
                    let timeDate = new Date(time[0])
                    let endDateTime = new Date(endDateSelected)
                    if (startDateTime.getTime() <= timeDate.getTime() && endDateTime.getTime() >= timeDate.getTime()) {
                        return time
                    }
                })
            })
            filteredTestData = filteredTestData.filter(station => {
                console.log(station.station)
                if (station.data.length !== 0) {
                    console.log(station.data.length)
                    return station
                }
            })
        }
        timeValues = filteredTestData.flatMap((station) => station.data.map(x => x[0])).sort((a, b) => Date.parse(a) - Date.parse(b));
        dataValues = filteredTestData.map((station) =>
            timeValues.map(time => {
                const val = station.data.find(x => x[0] === time.toString())
                if (val) {
                    return val[1]
                } else {
                    return null
                }
            })
        )
        //setting the lat lon of each value and the average value of each station
        filteredTestData.forEach(station => {
            let averagePrecip = 0
            station.data.forEach(event => {
                averagePrecip += Number(event[1])
            })
            averagePrecip = averagePrecip / station.data.length
            points.push(turf.point([station.lon, station.lat], {"Precipitation": averagePrecip}))
        })
        data = [timeValues.map(x => new Date(x).getTime() / 1000), ...dataValues];
    })

    function contourMake(points) {
        const collection = turf.featureCollection<Point>(points);
        const interpolate_options = {
            gridType: "point",
            property: "Precipitation",
            units: "degrees",
            weight: 10
        };
        const grid = turf.interpolate(collection, 0.05, interpolate_options);
        const isobands_options = {
            zProperty: "Precipitation",
            commonProperties: {
                "fill-opacity": 0.8
            },
            breaksProperties: [
                {fill: "#e3e3ff"},
                {fill: "#c6c6ff"},
                {fill: "#a9aaff"},
                {fill: "#8e8eff"},
                {fill: "#7171ff"},
                {fill: "#5554ff"},
                {fill: "#3939ff"},
                {fill: "#1b1cff"},
                {fill: "#1500ff"}
            ]
        };
        return turf.isobands(
            grid,
            [100, 125, 150, 175, 200, 225, 250],
            isobands_options
        );
    }


    function makeChart(data) {
        const config = {
            title: "Extremes Events",
            width: 800,
            height: 400,
            id: "chart1",
            series: [
                {}
            ],
            axes: [
                {},
            ],
        };

        let colors = ['rgba(255,0,0,.5)', 'rgba(0,255,0, .5)', 'rgba(0,0,255, .5)', 'rgba(255,255,0, .5)', 'rgba(0,255,255, .5)',
            'rgba(255,0,255, .5)', 'rgba(51,51,153, .5)', 'rgba(153,51,102, .5)', 'rgba(150,150,150, .5)', 'rgba(255,128,128, .5)']
        filteredTestData.forEach(station => {
            let color = colors.pop()
            config.series.push({
                show: true,
                spanGaps: true,
                label: station.station,
                value: (self, rawValue) => rawValue ? rawValue + "mm" : null,
                stroke: color,
                width: 5,
                fill: color,
                dash: [10, 5],
            })
        })
        new uPlot(config, data, plotContainer);
    }

    //TODO: change this around to be more standardized
    onMount(async () => {
        // probably going to have to change this when the searches get hooked up? sets up the format radio to automatically select the first option
        const formatInputs = document.querySelectorAll("input");
        const hasChecked = Array.from(formatInputs).some((input) => input.checked);
        if (!hasChecked) {
            formatInputs[0].checked = true;
        }
        makeChart(data);
    })

    function makeMarkers() {
        let markers = []
        filteredTestData.forEach((data) => {
            const el = document.createElement('div');
            const width = 40;
            const height = 40;
            el.className = 'marker';
            el.style.backgroundImage = `url("../icons/marker.svg")`;
            el.style.width = `${width}px`;
            el.style.height = `${height}px`;
            el.style.backgroundSize = '100%';
            markers.push(new Marker(el)
                .setLngLat([data.lon, data.lat])
                .setPopup(new Popup({offset: 25}).setHTML(
                    `<a href='../station-detail?stationPrefix=${datasetMetadata?.ncei.access.search.station.homrprefix}&stationId=${data.station}'\>${data.station}</a>`))
            )
        })
        return markers;
    }


</script>

<div class="container-fluid">
  <div class="row">
    <div class="col-sm-2 gx-0">
      <SideSearch>
        <WhenSearchInput slot="when" enabled={true} format={"DateTime"}/>
        <StaionSearchInputMock slot="stations" selectedStation={stationSelected}/>
      </SideSearch>
    </div>

    <main class="col-md-10">
      <!-- dataset title and map view followed by summary and search results -->
      <div class="row dataset">
        <div class="col pt-3 ps-3">
          <div>
            {#await promise}
              <h2 style="color: white;" class="placeholder-glow"><span class="placeholder col-7"></span>
              </h2>
            {:then value}
              <h2 style="color: white;">{datasetMetadata?.name}</h2>
            {:catch error}
              <h2 style="color: white;">{datasetMetadata?.name}</h2>
            {/await}
          </div>
          <div>
            <p style="color: white;" class="lead">
              Browse station files by map or file list, using any search options to narrow down your
              search.
            </p>
          </div>
        </div>
      </div>
      {#if !isError}
        <div class="row" style="background-color: #F1F3F6;">
          <div class="col-5 px-0">
            <MapComponent arrayPoints={makeMarkers()} mapSize={400} isobands={contourMake(points)}/>
          </div>
          <div class="col-7 mb-2">
            <div class="pt-3">
              <div>
                <h2>Collection Description and Map View</h2>
                {datasetMetadata?.ncei?.description}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div bind:this={plotContainer}/>
          </div>
        </div>
        <div class="row">
          <div class="col">
            {#each filteredTestData || [] as r, i (r.station)}
              <div class="card mb-3">
                <div class="card-body">
                  <h5 class="card-title">{r.station}</h5>
                  <div class="row card-text">
                    <div class="col fw-semibold">Return Interval (years): <br>{r.returnInterval}</div>
                    <div class="col fw-semibold">Duration Hour: <br>{r.durationHr}</div>
                    <div class="col fw-semibold">Threshold: <br>{r.thresholdmm} mm</div>
                    <div class="col fw-semibold"> Date:
                      <select
                              class="form-select form-select-sm"
                              aria-label="Small select example">
                        <option selected>Select Date:</option>
                        {#each r.data || [] as y}
                          <option value={y[0]}>{y[0]} / Amount : {y[1]}</option>
                        {/each}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            {/each}
          </div>
        </div>
      {:else}
        <div id="error-container">
          <div id="error-card">
            <p class="custom-error-message">Something went wrong.
            </p>
          </div>
        </div>
      {/if}

      <div class="my-4"></div>

    </main>
  </div>
</div>

<style>

    #map {
        height: 600px;
    }

    .cart-alert {
        height: 20%;
        width: 100%;
        position: fixed;
        z-index: 3;
        bottom: 0;
        right: 0;
        background-color: #F1F3F6;
        overflow-y: hidden;
    }

    .link:link {
        text-decoration: none;
    }

    .link:visited {
        text-decoration: none;
    }

    .link:hover {
        text-decoration: underline;
    }

    .link:active {
        text-decoration: underline;
    }

    .table-border {
        border-top: 1px solid #d1d1d1;

    }

    .form-check-input:focus {
        box-shadow: none;

    }

    .select {
        --bs-btn-color: #5EB6D9;
        --bs-btn-bg: white;
        --bs-btn-border-color: #5EB6D9;
        --bs-btn-hover-color: #309ec9;
        --bs-btn-hover-bg: white;
        --bs-btn-hover-border-color: #309ec9;
        --bs-btn-active-color: #38a5d0;
        --bs-btn-active-bg: white;
        --bs-btn-active-border-color: #38a5d0;
    }

    .select:hover {
        box-shadow: 0 0 .2rem rgba(0, 0, 0, .3);

    }

    .select-disabled {
        --bs-btn-color: #afdaec;
        --bs-btn-bg: white;
        --bs-btn-border-color: #afdaec;
        --bs-btn-hover-color: #afdaec;
        --bs-btn-hover-bg: white;
        --bs-btn-hover-border-color: #afdaec;
        --bs-btn-active-color: #afdaec;
        --bs-btn-active-bg: white;
        --bs-btn-active-border-color: #afdaec;

    }

    #error-container {
        height: 45vh;
    }

    #error-card {
        display: flex;
        width: 45%;
        background-color: #E7B1B6;
        margin: 3vh auto;
        border-radius: 2vh;
        padding: 2vh;
    }

    #error-container #error-card .custom-error-message {
        font-size: clamp(1rem, 2vw, 1.5rem);
        margin: auto;
    }
</style>

